
import React, { useRef, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
import { Eye, EyeOff, Phone, Mail, PenSquare, Info, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useToast } from '@/hooks/use-toast';
import { RootState } from '@/store';
import { setLoginMethod, loginStart, loginSuccess, loginFailure } from '@/store/slices/authSlice';
import { signUpVendor, login, sendVendorOTP, verifyVendorOTP,generateForgotPasswrodLinkForVendor } from '@/store/thunkMidddleware/authMiddleware';
import { getVendorProfile } from '@/store/thunkMidddleware/usersMiddleware';
import { useNavigate } from "react-router-dom";
import routes from '@/routes/routes.json'
import { InputOTP, InputOTPGroup, InputOTPSlot } from "@/components/ui/input-otp";
import { Dialog, DialogContent, DialogHeader, DialogFooter, DialogTitle } from "@/components/ui/dialog"

import { ButtonWithLoader } from '../ui/buttonwithloader';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import Strings from '@/constants/String';
import Antigravity from '@/assets/animation/Antigravity';

interface LoginScreenProps {
  onSwitchToSignup: () => void;
}

type ForgotPasswordDialogProps = {
  showForgotPasswordModal: boolean;
  setShowForgotPasswordModal: (val: boolean) => void;
  onConfirm?: () => void; // callback when vendor confirms
};

const validateEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
export const ForgotPasswordDialog = ({
  showForgotPasswordModal,
  setShowForgotPasswordModal,
}: ForgotPasswordDialogProps) => {
  const { toast } = useToast();
  const dispatch = useAppDispatch();

  const [email,setEmail] = useState('')
  const { generateForgotPasswrodLinkForVendorResponse} = useAppSelector((state: RootState) => state.auth);

  const triggerForgotPasswordLink=()=>{

    if (!validateEmail(email)) {
      toast({ title: 'Error', description: 'Please enter a valid email address', variant: 'destructive' });
      return;
    }

    dispatch(generateForgotPasswrodLinkForVendor(({payload:{email},callback:(res)=>{
      if(res?.payload){
        console.log(res?.payload)
        setEmail('')
        setShowForgotPasswordModal(false)
      }
      
    }})))

    

  }
  return (
    <Dialog
      open={showForgotPasswordModal}
      onOpenChange={(isOpen) => {
        setEmail('')
        setShowForgotPasswordModal(isOpen)
      }}
    >
      <DialogContent className="max-w-[500px] max-h-[90vh] p-0 bg-flup-surface flex flex-col">
        {/* Header */}
        <DialogHeader className="p-4 border-b">
          <DialogTitle className="text-lg font-semibold text-red-600">
            Forgot Password
          </DialogTitle>
        </DialogHeader>

        {/* Body */}
        <div className="flex-1 overflow-y-auto px-6  space-y-4 pb-4">
          <p className="text-sm text-black/80 flex items-center space-x-2">
           <Info className='w-4 h-4 text-orange-500'/> <span> 
           Please enter your Email ID to get the Reset link
            </span>
          </p>
           <div className="space-y-2">
            <Label htmlFor="email">Email ID*</Label>
             <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>  
        </div>

        {/* Footer */}
        <DialogFooter className="p-4 border-t flex gap-4">
          <Button
            variant="outline"
            onClick={() => {
              setEmail('')
              setShowForgotPasswordModal(false)
            }}
            className="flex-1"
            disabled={generateForgotPasswrodLinkForVendorResponse.isLoading}
          >
            Cancel
          </Button>
          <ButtonWithLoader
          isLoading={generateForgotPasswrodLinkForVendorResponse.isLoading}
          disabled={!email || generateForgotPasswrodLinkForVendorResponse.isLoading}
            onClick={() => {
              // onConfirm();
              triggerForgotPasswordLink()
            }}
            className="flex-1 bg-green-600 text-white hover:bg-green-700"
          >
            Proceed
          </ButtonWithLoader>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};


const LoginScreen: React.FC<LoginScreenProps> = ({ onSwitchToSignup }) => {
  let timer = null;
  const navigate = useNavigate()
  const dispatch = useAppDispatch();
  const authState = useAppSelector(state => state.auth)
  const profileState = useAppSelector(state => state.profile)
  // const [otp, setOtp] = useState(Array(4).fill("")); // Array with 6 empty strings
  const [otp, setOtp] = useState("");

  const { loginMethod, loading, error } = useAppSelector((state: RootState) => state.auth);

  const { toast } = useToast();
  const [showEmailOtp, setShowEmailOtp] = useState(false);
  const [isEmailOtpTrigged, setIsEmailOtpTrigged] = useState(false);

  const [showEmailPassword, setshowEmailPassword] = useState(true);
  const [enableResendOtpBtn, setEnableResendOtpBtn] = useState(false)
  const [showForgotPasswordModal,setShowForgotPasswordModal] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0); // 1 minutes in seconds


  const inputRefs = useRef([]); // Array of refs for each input field



  const startTimer = () => {
    let timer = null;
    timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setEnableResendOtpBtn(true)
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }

  const stopTimer = () => {
    clearInterval(timer);
    setTimeLeft(1 * 60)
  }


  const handlePhoneLogin = async () => {
    if (!phoneNumber) {
      toast({ title: 'Error', description: 'Please enter phone number', variant: 'destructive' });
      return;
    }

    dispatch(loginStart());
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      dispatch(loginSuccess({ phone: phoneNumber, id: '1' }));
      toast({ title: 'Success', description: 'OTP sent successfully!' });
    } catch (err) {
      dispatch(loginFailure('Failed to send OTP'));
    }
  };



  const fetchProfile = async (token: string) => {
    dispatch(getVendorProfile({
      token: token,
      callback: (profile) => {
        if (profile?.payload?.vendorProfileCompleted) {
          // Straight to the slot board — managing today's availability is what
          // a vendor signs in to do, so it is the landing screen, not a stop on
          // the way to one.
          navigate(routes.venueManagement)
        } else {
          navigate(routes.vendorOnboard)

        }
        console.log("getVendorProfile:", profile)
      }
    }))
  }

  const sendEmailOtpHandler = () => {
    sessionStorage.clear()
    localStorage.clear()
    if (!email) {
      toast({ title: 'Error', description: 'Please fill Email-Id field', variant: 'destructive' });
      return;
    }
    dispatch(sendVendorOTP({
      payload: { email: email }, callback: (res) => {
        console.log("res:", res)
        if (res?.success) {
          setIsEmailOtpTrigged(true)
          setEnableResendOtpBtn(false)
          startTimer()
          setTimeLeft(1 * 60)
        }
      }
    }))
  }

  const verifyEmailOtpHandler = () => {
    if (otp.length === 6 && email) {
      let req = {
        email: email,
        otp
      }
      dispatch(verifyVendorOTP({
        payload: req, callback: (res) => {
          if (res?.success || res?.payload?.token) {
            fetchProfile(res?.payload?.token)
          }
        }
      }))
    } else {
      toast({ title: 'Error', description: 'Please enter OTP', variant: 'destructive' });
    }
  }
  const handleEmailLogin = async () => {
    sessionStorage.clear()
    localStorage.clear()
    if (!email || !password) {
      toast({ title: 'Error', description: 'Please fill all fields', variant: 'destructive' });
      return;
    }
    // dispatch(loginStart());
    let payload = {
      email: email,
      password: password
    }
    dispatch(login({
      credentials: payload, callback: (res) => {
        console.log("res:", res)
        if (res) {
          fetchProfile(res?.payload?.token)
        }
      }
    }))

  };

  const handleEmailOtpLogin = () => {
    setShowEmailOtp(!showEmailOtp)
    setshowEmailPassword(!showEmailPassword)

  }

  const renderEmailPassswordLoginView = () => {
    if (showEmailPassword) {
      return (
        <>
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="password">Password</Label>
            <div className="relative">
              <Input
                id="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <Button
                type="button"
                variant="none"
                size="sm"
                className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </Button>
            </div>
          </div>

          <ButtonWithLoader
            isLoading={authState.isLoading || profileState.vendorProfile.isLoading}
            loaderPosition='right'
            onClick={handleEmailLogin}
            className="w-full bg-flup-brand hover:bg-flup-brand-press text-white"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </ButtonWithLoader>

        </>
      )
    }
  }

  const renderEmailOtpLoginView = () => {
    if (showEmailOtp) {

      return (
        <>
          {!isEmailOtpTrigged && <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>}


          {!isEmailOtpTrigged &&
            <ButtonWithLoader
              isLoading={authState.sendVendorOTPResponse.isLoading}
              loaderPosition='right'
              onClick={sendEmailOtpHandler}
              className="w-full bg-flup-brand hover:bg-flup-brand-press text-white"
              disabled={authState.sendVendorOTPResponse.isLoading}
            >
              {'Request OTP'}
            </ButtonWithLoader>
          }
          {isEmailOtpTrigged &&

            <div className="space-y-2">
              <div className="space-y-2">
                <Label className="text-sm font-medium text-flup-ink-3">
                  We have send you <span className="text-flup-ink-2"> One Time Password(OTP)</span> to your email:
                </Label>
                <Label className="text-sm font-bold text-flup-ink flex items-center">
                  {email} <PenSquare className='w-4 h-4 ml-2 text-green-500 hover:text-green-700' onClick={() => {
                    setEmail('')
                    setIsEmailOtpTrigged(false)
                  }} />
                </Label>
              </div>


              <div className="space-y-2 flex justify-start">
                <div className="space-y-2">
                  <Label className="text-sm font-medium text-flup-ink-2">
                    Enter 6-digit code
                  </Label>
                  <div className="flex justify-start">
                    <InputOTP
                      maxLength={6}
                      value={otp}
                      onChange={(value) => setOtp(value)}
                    >
                      <InputOTPGroup >
                        <InputOTPSlot index={0} className='p-4' />
                        <InputOTPSlot index={1} className='p-4' />
                        <InputOTPSlot index={2} className='p-4' />
                        <InputOTPSlot index={3} className='p-4' />
                        <InputOTPSlot index={4} className='p-4' />
                        <InputOTPSlot index={5} className='p-4' />
                      </InputOTPGroup>
                    </InputOTP>
                  </div>
                  {timeLeft > 0 && <Label className="text-xs  text-flup-ink-3">
                    Resend opt in: <span className='text-blue-800 font-bold'> {`${timeLeft} sec.`}</span>
                  </Label>}
                </div>
              </div>

              <div className='w-full flex justify-center space-x-4'>
                <ButtonWithLoader
                  disabled={!enableResendOtpBtn || authState.sendVendorOTPResponse.isLoading}
                  className='w-1/2'
                  isLoading={authState.sendVendorOTPResponse.isLoading}
                  onClick={() => {
                    setOtp('')
                    if (timeLeft < 1) {
                      sendEmailOtpHandler()
                    }
                  }}

                >
                  {Strings.btnText.resendotp}
                </ButtonWithLoader>

                <ButtonWithLoader
                  disabled={authState.verifyVendorOTPResponse.isLoading || profileState.vendorProfile.isLoading}
                  className='w-1/2'
                  onClick={verifyEmailOtpHandler}
                  isLoading={authState.verifyVendorOTPResponse.isLoading || profileState.vendorProfile.isLoading}
                >
                  {Strings.btnText.verifyotp}
                </ButtonWithLoader>
              </div>


            </div>
          }
        </>
      )
    }
  }



  
  return (
    <>


          <ForgotPasswordDialog
          setShowForgotPasswordModal={setShowForgotPasswordModal}
          showForgotPasswordModal={showForgotPasswordModal}
          />
    <div style={{ width: '100%', height: '100%', position: 'absolute',zIndex:1 }}>
      <Antigravity
        count={500}
        magnetRadius={6}
        ringRadius={7}
        waveSpeed={0.4}
        waveAmplitude={1}
        particleSize={1.6}
        lerpSpeed={0.05}
        // color={'#7400c2'}
        color={'#b6ece1'}

        autoAnimate={true}
        particleVariance={1}
        particleShape={"sphere"}
        // particleShape={"capsule"}
        // particleShape={"tetrahedron"} 
      />
    </div>
<div className="min-h-screen flex items-center justify-center bg-[url('/bg4.jpeg')] bg-cover bg-center bg-center bg-no-repeat bg-fixed">

  {/* Gray overlay */}
  <div className="absolute inset-0 bg-flup-ink/55"></div>

      <Card className="w-full max-w-md inset-0 z-20 m-2 sm:m-0 rounded-flup-xl border-flup-hairline shadow-flup-pop">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-display font-bold text-flup-ink">Vendor Login</CardTitle>
          <CardDescription>Choose your preferred login method</CardDescription>
        </CardHeader>
        <CardContent>
          <Tabs
            value={loginMethod}
            onValueChange={(value) => dispatch(setLoginMethod(value as 'email' | 'phone'))}
          >
            {/* <TabsList className="grid w-full grid-cols-2">

              <TabsTrigger value="email">
                <Mail className="w-4 h-4 mr-2" />
                Email
              </TabsTrigger>
              <TabsTrigger value="phone">
                <Phone className="w-4 h-4 mr-2" />
                Phone
              </TabsTrigger>

            </TabsList> */}


            <TabsContent value="email" className="space-y-4">


              {renderEmailPassswordLoginView()}

              {renderEmailOtpLoginView()}



              <Button variant="link" className="w-full" onClick={handleEmailOtpLogin}>
                {showEmailOtp ? "Login with password" : "Login with OTP instead"}
              </Button>
            </TabsContent>

            {/* <TabsContent value="phone" className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="phone">Phone Number</Label>
                <Input
                  id="phone"
                  type="tel"
                  placeholder="+91 9876543210"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                />
              </div>
              <Button
                onClick={handlePhoneLogin}
                className="w-full bg-flup-brand hover:bg-flup-brand-press text-white"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send OTP'}
              </Button>
            </TabsContent> */}


          </Tabs>

          {error && (
            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-600">{error}</p>
            </div>
          )}

          <div className="mt-0 text-center space-y-2">
            <Button variant="link" className="text-sm" onClick={()=>{setShowForgotPasswordModal(true)}}>
              Forgot Password?
            </Button>
            <div className="text-sm text-flup-ink-2">
              Don't have an account?{' '}
              <Button variant="link" onClick={onSwitchToSignup} className="p-0 h-auto">
                Sign Up
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
    </>
  );
};

export default LoginScreen;
